import React, { useState, useContext, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Layout } from 'blaze-validator';
import PropTypes from 'prop-types';
import { searchCustomer } from './layouts';
import LoyaltyContext from './LoyaltyContext';
import CustomerList from './CustomerList';
import LoadingPage from '../LoadingPage';
import Form from '../form/Form';
import '../../styles/loyalty.scss';

const CustomerSearch = ({ initialSearch, onSelect }) => {
  const [currentSearch, setCurrentSearch] = useState({});
  const [loading, setLoading] = useState(!!initialSearch);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearch, setShowSearch] = useState(true);

  const firstUpdate = useRef(true);

  const { fetchCustomers } = useContext(LoyaltyContext);

  const layout = new Layout(searchCustomer);

  const handleSubmit = payload => {
    const params = {};

    // Just remove empty strings
    Object.keys(payload).forEach(f => {
      if (payload[f] !== '') {
        if (typeof payload[f] === 'boolean') {
          if (payload[f]) {
            params[f] = true;
          }
          return;
        }

        params[f] = payload[f];
      }
    });

    setCurrentSearch(params);
    setLoading(true);

    return fetchCustomers(params).then(response => {
      setSearchResults(response.data);
      setLoading(false);
      setShowSearch(false);
    });
  };

  const buildQuery = () => {
    return Object.keys(currentSearch).map(k => {
      const { label } = layout.lookup[k];
      return {
        label,
        value: currentSearch[k],
      };
    });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      if (initialSearch) {
        handleSubmit(initialSearch);
      }
      firstUpdate.current = false;
    }
  }, []);

  const className = classNames({
    'loyalty-customer-search': true,
    loading,
  });

  if (loading && !!initialSearch) {
    return <LoadingPage message="Searching" style={{ height: '450px' }} />;
  }

  return (
    <div className={className}>
      {!showSearch ? (
        <CustomerList
          results={searchResults}
          query={buildQuery()}
          onQueryClick={() => setShowSearch(true)}
          onSelect={onSelect}
        />
      ) : (
        <Form
          layout={layout.populateLayout(currentSearch).getLayout()}
          exportFormat="object"
          submit={handleSubmit}
          submitAll
          hideCancel
          feedback="erroronly"
          trackDirty={false}
        />
      )}
    </div>
  );
};

CustomerSearch.propTypes = {
  initialSearch: PropTypes.object,
  onSelect: PropTypes.func,
};

export default CustomerSearch;
